import styled from 'styled-components'
import PropTypes from 'prop-types'

const ImgSyled = styled.div`
  position: relative;
  max-height: 80vh;
  aspect-ratio: 16 / 9;
  margin: 0 auto;
  .thumbnail {
    width: 100%;
  }
  .overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(
      117.13deg,
      rgba(59, 62, 82, 0.85) 0.59%,
      rgba(34, 36, 54, 0.85) 100%
    );
  }
`

function VideoOverlay({ thumbnails }) {
  return (
    <ImgSyled>
      <img
        srcSet={`${thumbnails[0]?.link} ${thumbnails[1]?.link} 2x`}
        src={thumbnails[1]?.link}
        className="thumbnail"
        alt="Video thumbnail"
      />
      <div className="overlay" />
    </ImgSyled>
  )
}

VideoOverlay.propTypes = {
  thumbnails: PropTypes.array.isRequired,
}

export default VideoOverlay
